module.exports = __webpack_public_path__ + "static/img/Michael-Roberts.f8dab54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Michael-Roberts.jpg
// module id = WUWN
// module chunks = 0